import { useSelector } from "react-redux";
import PanelLayout from "../../../layouts/PanelLayout";
import { RiFolderDownloadLine } from "react-icons/ri";
import AppContext from "../../../AppContext";
import React, { useState } from "react";
import { Container, Table, Button, Card, Modal } from "react-bootstrap";

function FacturasList() {
  const ctacte = useSelector((state) => state.ctacte);
  const baseApiUrl = `${AppContext.baseApiUrl}/${AppContext.urlServiceFactura}`;
  const [mostrarModal, setMostrarModal] = useState(false);
  const [cuotaSeleccionada, setCuotaSeleccionada] = useState(null);

  const procesarMovimientos = (items, tipo) => {
    return items
      .filter(
        (item) =>
          Number(item.mes) !== 0 &&
          (Number(item.debe || 0) > 0 || Number(item.interes || 0) > 0)
      )
      .map((mov) => {
        const pagoRelacionado = ctacte.find(
          (p) =>
            (p.codcomprobante === "FC" || p.codcomprobante === "FE") &&
            Number(p.idInternoComprobantePagado) ===
              Number(mov.idInternoComprobante)
        );

        const pagado = !!pagoRelacionado;
        const fechaMostrar = pagoRelacionado
          ? new Date(pagoRelacionado.fecha)
          : new Date(mov.fecha);

        const debe = pagado
          ? Number(mov.debe || 0)
          : Number(mov.debe || 0) + Number(mov.interes || 0);

        return {
          idctacte: mov.idctacte,
          fecha: fechaMostrar,
          anio: mov.anio,
          mes: mov.mes,
          detalle: mov.detalle,
          debe,
          pagado,
          idInternoComprobante: mov.idInternoComprobante,
          llave: pagoRelacionado?.llave || null,
          nrofactura: pagoRelacionado?.nrofactura || null,
          tipo,
        };
      })
      .filter((item) => {
        const fechaItem = new Date(item.fecha);
        const hoy = new Date();
        const fechaDesde = new Date(hoy.getFullYear(), hoy.getMonth() - 6, 1);
        const fechaHasta = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 31);

        return fechaItem >= fechaDesde && fechaItem <= fechaHasta;
      });
  };

  const cuotas = procesarMovimientos(
    ctacte.filter((i) => i.codcomprobante === "C"),
    "Cuota"
  );

  const matriculas = procesarMovimientos(
    ctacte.filter((i) => i.codcomprobante === "M"),
    "Matrícula"
  );

  const todosLosMovimientos = [...cuotas, ...matriculas].sort((a, b) => {
    if (a.pagado !== b.pagado) return a.pagado ? 1 : -1;
    return b.fecha - a.fecha;
  });

  const abrirPago = (item) => {
    setCuotaSeleccionada(item);
    setMostrarModal(true);
  };

  return (
    <PanelLayout>
      <Container className="py-3 py-md-4">
        <div className="facturas-page-header mb-4">
          <div>
            <p className="facturas-page-kicker mb-2">Portal de Familias</p>
            <h1 className="facturas-page-title mb-1">Cuotas y matrículas</h1>
            <p className="facturas-page-subtitle mb-0">
              Consultá tus movimientos, estado de pago y acceso a facturas.
            </p>
          </div>
        </div>

        <Card className="facturas-page-card border-0 shadow-sm">
          <Card.Body className="p-0">
            <div className="d-none d-lg-block">
              <Table hover responsive bordered={false} className="align-middle mb-0">
                <thead className="table-light">
                  <tr>
                    <th>Fecha</th>
                    <th>Período</th>
                    <th>Detalle</th>
                    <th>Tipo</th>
                    <th>Importe</th>
                    <th>Estado</th>
                    <th className="text-end">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {todosLosMovimientos.length === 0 ? (
                    <tr>
                      <td colSpan="7" className="text-center text-muted py-4">
                        No hay registros dentro del rango.
                      </td>
                    </tr>
                  ) : (
                    todosLosMovimientos.map((item) => (
                      <tr key={item.idctacte}>
                        <td>{item.fecha.toLocaleDateString("es-AR")}</td>
                        <td>
                          {item.anio} / {item.mes}
                        </td>
                        <td>{item.detalle}</td>
                        <td>{item.tipo}</td>
                        <td>${item.debe.toLocaleString("es-AR")}</td>
                        <td>
                          <span
                            className={`factura-status-badge ${
                              item.pagado ? "pagada" : "pendiente"
                            }`}
                          >
                            {item.pagado ? "Pagada" : "Pendiente"}
                          </span>
                        </td>
                        <td className="text-end">
                          {item.pagado ? (
                            <Button
                              size="sm"
                              variant="outline-primary"
                              onClick={() =>
                                window.open(`${baseApiUrl}/${item.llave}`, "_blank")
                              }
                              disabled={!item.llave}
                            >
                              Descargar <RiFolderDownloadLine size={18} />
                            </Button>
                          ) : (
                            <Button
                              size="sm"
                              variant="outline-primary"
                              onClick={() => abrirPago(item)}
                            >
                              Ver pago
                            </Button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>

            <div className="d-lg-none facturas-mobile-list">
              {todosLosMovimientos.length === 0 ? (
                <div className="text-center text-muted py-5 px-3">
                  No hay registros dentro del rango.
                </div>
              ) : (
                todosLosMovimientos.map((item) => (
                  <div key={item.idctacte} className="factura-mobile-card">
                    <div className="factura-mobile-top">
                      <div>
                        <p className="factura-mobile-type mb-1">{item.tipo}</p>
                        <h3 className="factura-mobile-detail mb-0">{item.detalle}</h3>
                      </div>
                      <span
                        className={`factura-status-badge ${
                          item.pagado ? "pagada" : "pendiente"
                        }`}
                      >
                        {item.pagado ? "Pagada" : "Pendiente"}
                      </span>
                    </div>

                    <div className="factura-mobile-amount">
                      ${item.debe.toLocaleString("es-AR")}
                    </div>

                    <div className="factura-mobile-grid">
                      <div className="factura-mobile-meta">
                        <span>Fecha</span>
                        <strong>{item.fecha.toLocaleDateString("es-AR")}</strong>
                      </div>
                      <div className="factura-mobile-meta">
                        <span>Período</span>
                        <strong>
                          {item.anio} / {item.mes}
                        </strong>
                      </div>
                      <div className="factura-mobile-meta">
                        <span>Acción</span>
                        <strong>{item.pagado ? "Descargar" : "Ver pago"}</strong>
                      </div>
                    </div>

                    {item.pagado ? (
                      <Button
                        size="sm"
                        variant="primary"
                        className="w-100 factura-mobile-btn"
                        onClick={() =>
                          window.open(`${baseApiUrl}/${item.llave}`, "_blank")
                        }
                        disabled={!item.llave}
                      >
                        Descargar factura <RiFolderDownloadLine size={18} />
                      </Button>
                    ) : (
                      <Button
                        size="sm"
                        variant="outline-primary"
                        className="w-100 factura-mobile-btn"
                        onClick={() => abrirPago(item)}
                      >
                        Ver datos para pagar
                      </Button>
                    )}
                  </div>
                ))
              )}
            </div>
          </Card.Body>
        </Card>
      </Container>

      <Modal
        show={mostrarModal && !!cuotaSeleccionada}
        onHide={() => setMostrarModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Datos para el pago</Modal.Title>
        </Modal.Header>
        <Modal.Body className="fs-6">
          <p>
            <strong>Banco:</strong> Galicia
          </p>
          <p>
            <strong>Titular:</strong> FUNDACION COLEGIO SANTO TOMAS
          </p>
          <p>
            <strong>CBU:</strong> 0070251720000002576217
          </p>
          <p>
            <strong>CUIT:</strong> 30-70777161-1
          </p>
          <p>
            <strong>Alias:</strong> colegiosantotomas.g
          </p>
          <p>
            <strong>Monto:</strong> ${cuotaSeleccionada?.debe.toLocaleString("es-AR")}
          </p>
          <p>
            <strong>Detalle:</strong> {cuotaSeleccionada?.detalle}
          </p>
          <p className="text-danger fw-bold">
            Si desea hacer una transferencia, por favor informar vía mail o
            WhatsApp para poder acreditar el pago.
          </p>
          <p>
            <strong>Tel:</strong> 2954-313911
          </p>
          <p>
            <strong>Mail:</strong> administracion@fundacioncolegiosantotomas.com.ar
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </PanelLayout>
  );
}

export default FacturasList;
